export default __webpack_public_path__ + "static/blog-article-30203e4fea7f9672491f5f5636e50e96.png";